import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Caja } from "@/shared/types/caja";

export async function getCaja(id: string): Promise<Caja> {
    await sleep(1000);
    const response = await api.get("cajas/" + id);
    return response.data;
}

export function useGetCajaQuery(id: string, queryConfig: QueryConfig<Caja> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCaja(id),
        queryKey: ["cajas", id],
    })
}

export interface GetCajaQueryProps {
    id: string,
    queryConfig?: QueryConfig<Caja>,
    children?: (queryResult: QueryResult<Caja>) => ReactNode
}

export function GetCajaQuery({
    id,
    children,
    queryConfig
}: GetCajaQueryProps) {
    const queryResult = useGetCajaQuery(id, queryConfig);
    return children && children(queryResult);
}